<template>
  <div class="popover-warp">
    <i class="icon-close w-icon-close" @click="cancel"></i>
    <div class="popover-warp-body">
      <div class="add-question">
        <w-input
          v-model="selfReasonData"
          :maxlength="1000"
          placeholder="请输入自定义扣分原因说明"
        ></w-input>
        <i class="w-icon-plus icon-plus-logo" @click="addQuestion()"></i>
      </div>
      <div class="delete-question">
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADbSURBVDhPjZKxDcJADEUNNQMwQIoMQcG2jJCSgiIjMEAKBqBEIryf2FF8HAqWvuz739+xLmeK0ez4NusE1RNZBPwB/QJu1G2QMt7Jo+B1GsBZRpmi50FujUJfm8iVuAwgJ2NAPftpdBE7ptJwpaEhd5xPLuVATGuvAf/6wc9rbw0okYwREJsDqsYIxAZUV3WcvTUHQvVW1/DN8juA2DQG0gCKv42BZQDFpRQFeF3O2Rtrei9z7fUst0qu/gW4QWLrzV/GCM7l+3+S51enZoneUP2P8BrQg2E2mn0Apbkx9hnwX4UAAAAASUVORK5CYII="
          class="ml-10 arrow-cell"
          @click="deleteQuestion()"
        />
      </div>
      <div class="add-question-list">
        <w-tree
          ref="reasonTree"
          :data="reasonList"
          show-checkbox
          node-key="id"
          default-expand-all
          :props="defaultProps"
        ></w-tree>
      </div>
    </div>
    <div class="popover-footer">
      <div class="popover-footer--right">
        <w-button @click="cancel">取消</w-button>
        <w-button type="primary" @click="confirm">确认</w-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'reason',
  props: {
    reasonList: {
      type: Array,
      default: () => {
        return []
      }
    },
    selfReason: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'YYMC'
      },
      selfReasonData: this.selfReason
    }
  },
  computed: {
    keyNames() {
      return {
        values: this.valueKey,
        labels: this.labelKey,
        other: this.otherKey
      }
    }
  },

  methods: {
    handleNodeClick(data, node) {
      if (!data.children) {
        node.checked = !node.checked
      }
    },
    //确认 按钮提交
    confirm() {
      this.$emit('selfReason', this.$refs.reasonTree.getCheckedNodes())
      this.$emit('hide')
    },
    //取消
    cancel() {
      this.$emit('hide')
    },
    //改变值
    changeValue(val) {
      //   this.detail = val
      //   //没有底部foot 马上刷新
      //   if (!this.hasFooter) {
      //     this.$emit('changeValue', this.detail)
      //   }
    },
    addQuestion() {
      this.$emit('selfReason', this.selfReasonData)
    },
    deleteQuestion() {
      this.$emit('deleteSelfReason', this.$refs.reasonTree.getCheckedNodes())
    }
  }
}
</script>

<style lang="scss" scoped>
.popover-warp {
  max-width: 400px;
}
.delete-question {
  text-align: right;
  margin-right: 14px;
  margin-bottom: 2px;
}
.delete-question img {
  width: 13px;
}
.add-question {
  .w-input {
    width: 90%;
  }
  .w-icon-plus {
    width: 20px;
    height: 20px;
    margin: auto;
    cursor: pointer;
  }
  display: flex;
  padding: 20px 0 0 0;
}
.add-question-list {
  border: 1px solid #c9c9c9;
  min-height: 100px;
  max-height: 400px;
  overflow: auto;
}
</style>
